// extracted by mini-css-extract-plugin
module.exports = {"base":"PremiumBadge_base__3WC3e"};